var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isIE)?_c('span',{staticClass:"x-ie text-primary text-4xl cursor-pointer leading-none pr-1"},[_vm._v("X")]):_c('span',{staticClass:"x block w-10 h-10 z-1 cursor-pointer"})}
var staticRenderFns = []

export { render, staticRenderFns }